









import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import Enumerable from 'linq';

class ColorValue {
  public constructor(public num: number,
                     public isSelected: boolean) {}
}

@Component({
  components: {
  },
})
export default class CharacterIconPicker extends Vue {
  @Prop() public value!: number;
  @Prop({
    default: () => [],
  }) public countries!: api.Country[];

  public get values(): ColorValue[] {
    const vs: ColorValue[] = [];
    for (let i = 1; i < def.COUNTRY_COLOR_NUM; i++) {
      vs.push(new ColorValue(i, this.value === i));
    }
    return vs;
  }

  private get defaultIconMax(): number {
    return def.DEFAULT_ICON_NUM;
  }

  private isAlready(color: number): boolean {
    return Enumerable
      .from(this.countries)
      .any((c) => color === c.colorId);
  }
}
